import { useCallback } from 'react';
import { bridge, isNotNil } from 'shared/src/utils';
import { AdAction } from 'shared/src/utils/eventLogger/adLogger/types';
import type { GoodsListCardItem } from '../utils/convertGoodsListItemToGoodsData';
import { getGoodsAnalytics } from './getGoodsAnalytics';

type Params = {
  type: string;
  listId: string | undefined;
  listParams: string | undefined;
};

export const useLogClickLikeGoods = (params: Params) => {
  return useCallback(
    (pressed: GoodsListCardItem, index: number, isLike: boolean) => {
      const eventType = isLike ? 'CLICK_LIKE_GOODS' : 'CLICK_UNLIKE_GOODS';
      bridge.logAnalyticsEvent({
        name: eventType,
        analytics: getGoodsAnalytics(pressed, index, params),
      });
      if (isNotNil(pressed.item.ad)) {
        bridge.logAdEvent({
          action: isLike ? AdAction.LIKE : AdAction.UNLIKE,
          ad: pressed.item.ad,
        });
      }
    },
    [params],
  );
};
